import Tooltip from "@mui/material/Tooltip";

import { ProgressBar } from "../../../../components/ProgressBar";
import { getCurrencySymbol, getNumberFormat } from "../../../../utils";
import {
  CategoryEmpty,
  CategoryLabel,
  CategoryList,
  CategoryRow,
  CategorySwatch,
  CategoryValue,
  LabelGroup,
} from "./styles";
import { CategoriesBreakdownProps } from "./types";

// Minimum fill so a tiny category still reads as a bar, not an empty track.
const MIN_FILL_PCT = 3;

const formatValue = (value: number, isExpense: boolean): string => {
  const sign = isExpense ? "-" : "";
  return `${sign}${getNumberFormat(value)} ${getCurrencySymbol("EUR")}`;
};

export const CategoriesBreakdown: React.FC<CategoriesBreakdownProps> = ({
  points,
  isExpense,
}) => {
  if (points.length === 0) {
    return <CategoryEmpty>No categories for this selection</CategoryEmpty>;
  }

  const max = Math.max(...points.map((point) => point.value), 1);

  return (
    <CategoryList>
      {points.map((point) => (
        <CategoryRow key={point.label}>
          <LabelGroup>
            <CategorySwatch $color={point.color} />
            <Tooltip title={point.label} placement="top">
              <CategoryLabel>{point.label}</CategoryLabel>
            </Tooltip>
          </LabelGroup>
          <ProgressBar
            value={point.value}
            max={max}
            color={point.color}
            minFillPct={MIN_FILL_PCT}
            ariaLabel={point.label}
          />
          <CategoryValue>{formatValue(point.value, isExpense)}</CategoryValue>
        </CategoryRow>
      ))}
    </CategoryList>
  );
};
